import React from 'react';
import { NodeTreeFacade } from "../model/NodeTreeFacade";
export var useNodeTree = function useNodeTree(nodes, components) {
  return React.useMemo(function () {
    return new NodeTreeFacade(nodes, components);
  }, [nodes, components]);
};